const pagination = {
  data () {
    return {
      paginationInit: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      }
    }
  }
}

export { pagination }
